import {
  DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_BEGIN,
  DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_SUCCESS,
  DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_FAILURE,
  DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadAppwriteCollectionDetails(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const { projectId, version, collectionId } = args;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/appwrites/get-collection/${collectionId}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAppwriteCollectionDetailsError() {
  return {
    type: DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_BEGIN:
      return {
        ...state,
        loadAppwriteCollectionDetailsPending: true,
        loadAppwriteCollectionDetailsError: null,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_SUCCESS:
      return {
        ...state,
        loadAppwriteCollectionDetailsPending: false,
        loadAppwriteCollectionDetailsError: null,
        collectionDetailsByAppwrite: action.data,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_FAILURE:
      return {
        ...state,
        loadAppwriteCollectionDetailsPending: false,
        loadAppwriteCollectionDetailsError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_COLLECTION_DETAILS_DISMISS_ERROR:
      return {
        ...state,
        loadAppwriteCollectionDetailsError: null,
      };

    default:
      return state;
  }
}
